module.exports = __webpack_public_path__ + "static/media/nguHoangCordi.174bf994.png";